<template>
  <div class="bb-string-cell">

  </div>
</template>

<script>
export default {
  name: 'BBStringSell'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Main/BBForm/BBStringSell/BBStringSell.vue